import React, { useEffect } from 'react';

const Links = () => {
  useEffect(() => {
    window.location.replace('https://mlickn.com');
  }, []);

  return (
    <div className="min-h-screen bg-[#303030] text-white flex flex-col items-center justify-center p-8">
      <div className="max-w-md text-center p-8 bg-[#202020] rounded-2xl border border-neutral-700">
        <h1 className="text-2xl font-bold mb-4">Melikşah Sakanyeri</h1>
        <p className="text-neutral-400 mb-6">Profile sayfasına yönlendiriliyorsunuz...</p>
        <a 
          href="https://mlickn.com" 
          className="inline-block px-6 py-2.5 bg-rose-600 hover:bg-rose-500 rounded-xl text-white font-medium transition-colors"
        >
          Profile Git (mlickn.com)
        </a>
      </div>
    </div>
  );
};

export default Links; 